import { fonts } from "./fonts";

const baseFontSize = 14;
const baseLineHeight = baseFontSize * 1.3;

export const headlines = {
    h1: {
        ...fonts.medium,
        fontSize: baseFontSize * 2.5,
        lineHeight: baseLineHeight * 2.5,
        marginBottom: (baseFontSize * 2.5) / 2,
    },
    h2: {
        ...fonts.medium,
        fontSize: baseFontSize * 2,
        lineHeight: baseLineHeight * 2,
        marginBottom: (baseFontSize * 2) / 2,
    },
    h3: {
        ...fonts.medium,
        fontSize: baseFontSize * 1.75,
        lineHeight: baseLineHeight * 1.75,
        marginBottom: (baseFontSize * 1.75) / 2,
    },
    h4: {
        ...fonts.medium,
        fontSize: baseFontSize * 1.5,
        lineHeight: baseLineHeight * 1.5,
        marginBottom: (baseFontSize * 1.5) / 2,
    },
    h5: {
        ...fonts.medium,
        fontSize: baseFontSize * 1.25,
        lineHeight: baseLineHeight * 1.25,
        marginBottom: (baseFontSize * 1.25) / 2,
    },
};
